module.exports = __webpack_public_path__ + "img/cover-1@3x.c58c42e7.png";